import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/** 椭圆实体 */
export class EllipseEntity extends BaseEntity {
  /** 椭圆中心 */
  center!: IPoint
  /** 相对于中心点的长轴端点，其长度即长轴半径 */
  majorAxisEndPoint!: IPoint
  /** 短轴与长轴的比例，取值 (0, 1] */
  axisRatio: number = 1
  /** 起始角，单位弧度 */
  startAngle: number = 0
  /** 终止角，单位弧度，默认 2π 表示整椭圆 */
  endAngle: number = 2 * Math.PI
  /** 是否顺时针方向 */
  clockwise: boolean = false

  protected readonly serializeKeys: string[] = [
    'center',
    'majorAxisEndPoint',
    'axisRatio',
    'startAngle',
    'endAngle',
  ]

  constructor(data: Partial<EllipseEntity>) {
    super(EntityType.Ellipse)
    Object.assign(this, data)
  }

  /** 长轴半径，单位米 */
  get radiusX() {
    return Math.hypot(this.majorAxisEndPoint.x, this.majorAxisEndPoint.y)
  }

  /** 短轴半径，单位米 */
  get radiusY() {
    return this.radiusX * this.axisRatio
  }

  /** 长轴相对 X 轴的旋转角，单位弧度 */
  get rotation() {
    return Math.atan2(this.majorAxisEndPoint.y, this.majorAxisEndPoint.x)
  }

  /**
   * 获取捕捉数据，返回椭圆中心。
   *
   * @returns 仅包含圆心的捕捉数据
   */
  getCaptureData() {
    return {
      centerPoints: [{ x: this.center.x, y: this.center.y }],
    }
  }
}
